// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-547bb722]:root{--active-color:#f08700;--primary-color:#f08700;--hover-color:#fff;--green-color:#66ff6d;--red-color:#cd7373;--border-radius:6px;--border-radius-desktop:8px}.direct-new[data-v-547bb722]{padding-bottom:var(--nav-height)}@media(min-width:992px){.direct-new[data-v-547bb722]{padding-bottom:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
